





































































































































































































import GeoFinderField from "@/components/utility/GeoFinderField.vue";
import { autoCompleteCountryCodes } from "@/lib/CountryCodeHelper";
import { ReportRoleEnum } from "@/lib/enum/ReportRole.enum";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";
import { requiredRule } from "@/lib/rules/requiredRule";
import { AccidentDetails } from "@/models/accident-details.entity";
import { Accident, IAccident } from "@/models/accident.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";
import { beforeCurrentDateRule } from "@/lib/rules/dateRule";
@Component({
  components: { GeoFinderField },
  filters: {}
})
export default class AccidentForm extends Vue {
  countryCodes = autoCompleteCountryCodes;
  ReportRoleEnum = ReportRoleEnum;
  TripTypeEnum = TripTypeEnum;

  @Prop({ default: new Accident() })
  value!: IAccident;

  get required() {
    return [requiredRule()];
  }

  get report() {
    return PartnerModule.report;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get accidentDetails() {
    return this.value.details ?? new AccidentDetails();
  }

  get accidentAddress() {
    return this.accidentDetails.address;
  }

  get beforeCurrentDateRule() {
    return [beforeCurrentDateRule()];
  }

  get maxDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
}
